import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { Icon } from 'ui';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  setSelectedRowAction,
} from '../../common/toolbar/containers/toolbar-dynamic-actions-actions';
import { setOpenActions } from '../../worklist/containers/worklist-actions';

const LinkActions = styled.div`
  margin-left: 5px;
  margin-right: 0px;
  margin-top: 4px;
  height: 20px;
  min-width: 26px !important;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: ${p => p.visible ? 'visible' : 'hidden'};
  background-color: ${p => p.visible ? '#FFF' : 'transparent'};
`;

const StyledActionIcon = styled(Icon)`
  color: #999;
  &:hover {
    cursor: pointer;
  }
`;

const Menu = styled.div`
`;

const MenuItem = styled.div`
  cursor: pointer;
  padding: 4px 12px;
  &:hover {
    color: white;
    background-color: #999;
  }
`;

const RowActions = ({ id, actions }) => {
  const openMenuId = useSelector(state => state.worklist.openActions);
  const [hovered, setHovered] = useState(false);
  const menuRef = useRef(hovered);
  menuRef.current = hovered;
  const dispatch = useDispatch();

  const handleActionClick = (action) => {
    dispatch(setSelectedRowAction(action));
  };

  const handleActionsClick = (e) => {
    e.stopPropagation();
    if (!openMenuId || openMenuId !== id) {
      dispatch(setOpenActions(id));
    } else {
      dispatch(setOpenActions(''));
    }
  };

  const menu = () => <Menu
    onMouseEnter={() => setHovered(true)}
    onMouseLeave={() => {
      dispatch(setOpenActions(''));
      setHovered(false);
    }}
  >
    {actions?.filter(a => a.id !== 'drag' && a.id !== 'createSubOrder')?.map(a =>
      <MenuItem key={a.id} onClick={() => handleActionClick(a)}>
        {a?.description?.replace('(s)', '')}
      </MenuItem>,
    )}
  </Menu>;

  if (!actions?.length) {
    return null;
  }

  return (
    <Popover
      content={menu}
      open={openMenuId === id}
      overlayClassName='actions-popover'
      placement='bottomRight'
    >
      <LinkActions
        className='actions'
        onClickCapture={handleActionsClick}
        visible={openMenuId === id}
        onMouseLeave={() => setTimeout(() => {
          if (!menuRef.current && openMenuId === id) {
            dispatch(setOpenActions(''));
          }
        }, 2000)}
      >
        <StyledActionIcon type='ellipsis-h' solid={true} size='sm' />
      </LinkActions>
    </Popover>
  );
};

RowActions.propTypes = {
  id: PropTypes.string,
  actions: PropTypes.actions,
};

export default RowActions;
